var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import "./campaign.css";
import { useEffect, useState } from "react";
import { api } from "../../services/http.service";
import { env } from "../../constants/global.constants";
import { auth } from "../../store/auth.store";
import { modalServiceSubject } from "../../services/modal.service";
import { useNavigate, useParams } from "react-router";
import paths from "../../paths";
import { copyMemberNumber } from "../../services/misc.functions";
import { isMobile } from "../../App";
export function CampaignDetail() {
    var navigate = useNavigate();
    var kampanya_id = useParams().kampanya_id;
    var _a = useState(null), campaign = _a[0], setCampaign = _a[1];
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState(0), selectedTab = _c[0], setSelectedTab = _c[1];
    var joinCampaign = function (id) {
        if (auth.member) {
            api
                .start("post", env.accounting_api + "/misc/api/create-member-campaign/", { campaign_id: id }, true)
                .then(function (res) {
                if (res && res.status) {
                    if (id === 8 || id === 107 || id === 206) {
                        // Arkadaşını Getir Kampanyası
                        modalServiceSubject.next({
                            case: "info",
                            title: "Başarılı!",
                            content: "<p class=\"text-center\">Kampanya'ya kat\u0131l\u0131m\u0131n\u0131z ger\u00E7ekle\u015Fmi\u015Ftir.</p><p class=\"text-center\">".concat(env.web_link, "/uye-ol?referer=").concat(auth.member.id.toString(16).toUpperCase(), "</p>"),
                            confirm: {
                                sure: {
                                    label: "Referans Linki Kopyala",
                                    action: function () {
                                        copyMemberNumber("".concat(env.web_link, "/uye-ol?referer=").concat(auth.member.id.toString(16).toUpperCase()), "Referans Linkiniz kopyalandı!");
                                    },
                                },
                            },
                        });
                    }
                    else {
                        modalServiceSubject.next({
                            case: "success",
                            title: "Başarılı!",
                            content: "<p class=\"text-center\">Kampanya'ya kat\u0131l\u0131m\u0131n\u0131z ger\u00E7ekle\u015Fmi\u015Ftir.</p>",
                            confirm: {
                                cancel: {
                                    label: "Tamam",
                                    class: "btn-success w-100",
                                    action: function () {
                                        getCampaign();
                                    },
                                },
                            },
                        });
                    }
                    getCampaign();
                }
                else {
                    modalServiceSubject.next({
                        case: "danger",
                        title: "İşlem Başarısız!",
                        content: "<p class=\"text-center\">".concat(res.message ? res.message : "", "</p>"),
                        confirm: {
                            cancel: {
                                class: "btn-danger",
                                label: "Tamam",
                            },
                        },
                    });
                }
            });
        }
        else {
            modalServiceSubject.next({
                class: "success",
                title: "Üye Girişi",
                content: "<p>Kampanya'ya kat\u0131lmak i\u00E7in \u00F6nce oturum a\u00E7man\u0131z gerekli. \u00DCye de\u011Filseniz hemen \u00FCye olabilir yada giri\u015F yaparak kampanya'ya kat\u0131labilirsiniz.</p>",
                confirm: {
                    sure: {
                        label: "Giriş Yap",
                        class: "btn btn-success",
                        action: function () {
                            navigate(paths.login.url);
                        },
                    },
                    cancel: {
                        label: "Üye Ol",
                        class: "btn btn-info",
                        action: function () {
                            navigate(paths.register.url);
                        },
                    },
                },
            });
        }
    };
    var getCampaign = function () {
        if (!kampanya_id)
            return;
        setLoading(true);
        var endpoint = auth.member
            ? env.accounting_api + "/misc/api/list_campaign_control/"
            : env.accounting_api + "/misc/api/list-campaign/";
        api
            .start("get", endpoint, null, true)
            .then(function (res) {
            if (res && res.status) {
                var foundCampaign = res.data.find(function (c) { return c.id.toString() === kampanya_id; });
                if (foundCampaign) {
                    setCampaign(foundCampaign);
                }
                else {
                    navigate(paths.campaign.url);
                }
            }
            setLoading(false);
        })
            .catch(function () {
            setLoading(false);
            navigate(paths.campaign.url);
        });
    };
    useEffect(function () {
        getCampaign();
    }, [kampanya_id]);
    useEffect(function () {
        if (campaign) {
            setSelectedTab(campaign.is_valid ? 0 : 1);
        }
    }, [campaign]);
    if (loading) {
        return (_jsx("div", __assign({ className: "campaigns mt-3" }, { children: _jsx("div", __assign({ className: "row" }, { children: _jsx("div", __assign({ className: "col-12 text-center py-5" }, { children: _jsx("p", { children: "Y\u00FCkleniyor..." }) })) })) })));
    }
    if (!campaign) {
        return null;
    }
    return (_jsxs("div", __assign({ className: "campaigns mt-3" }, { children: [isMobile && (_jsx("div", __assign({ className: "row inner-page-top-tabs mb-4" }, { children: _jsxs("div", __assign({ className: "liner-tabs", style: { "--tab-count": "2" } }, { children: [_jsx("input", { type: "radio", value: "0", checked: selectedTab === 0, "data-rel": "tab1", id: "campaign-detail-tab-1", onChange: function () {
                                setSelectedTab(0);
                                navigate("".concat(paths.campaign.url, "?tab=0"));
                            }, name: "tabs" }), _jsx("label", __assign({ className: "tab text-center", htmlFor: "campaign-detail-tab-1" }, { children: "G\u00FCncel Kampanyalar\u0131m\u0131z" })), _jsx("input", { type: "radio", value: "1", "data-rel": "tab2", checked: selectedTab === 1, id: "campaign-detail-tab-2", onChange: function () {
                                setSelectedTab(1);
                                navigate("".concat(paths.campaign.url, "?tab=1"));
                            }, name: "tabs" }), _jsx("label", __assign({ className: "tab text-center", htmlFor: "campaign-detail-tab-2" }, { children: "Ge\u00E7mi\u015F Kampanyalar\u0131m\u0131z" })), _jsx("span", { className: "glider" })] })) }))), !isMobile && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "row mt-3 raffle-page-title-bar" }, { children: _jsx("h1", __assign({ className: "fs-5 fw-bold mx-2 text-uppercase" }, { children: "Kampanyalar" })) })), _jsx("div", __assign({ className: "row" }, { children: _jsx("div", __assign({ className: "mb-0 mt-1" }, { children: _jsxs("div", __assign({ className: "custom-tabs" }, { children: [_jsx("div", __assign({ className: "custom-tab-item ".concat(selectedTab === 0 ? 'active' : ''), onClick: function () {
                                            setSelectedTab(0);
                                            navigate("".concat(paths.campaign.url, "?tab=0"));
                                        } }, { children: _jsx("h2", __assign({ className: "fs-6 fw-bold mb-0" }, { children: "G\u00FCncel Kampanyalar\u0131m\u0131z" })) })), _jsx("div", __assign({ className: "custom-tab-item ".concat(selectedTab === 1 ? 'active' : ''), onClick: function () {
                                            setSelectedTab(1);
                                            navigate("".concat(paths.campaign.url, "?tab=1"));
                                        } }, { children: _jsx("h2", __assign({ className: "fs-6 fw-bold mb-0" }, { children: "Ge\u00E7mi\u015F Kampanyalar\u0131m\u0131z" })) }))] })) })) }))] })), _jsx("div", __assign({ className: "row" }, { children: _jsx("div", __assign({ className: "col-12" }, { children: _jsxs("div", __assign({ className: "campaign-detail-page" }, { children: [!campaign.is_valid && (_jsx("div", __assign({ className: "ribbon ribbon-old" }, { children: _jsx("span", { children: "Ge\u00E7mi\u015F" }) }))), _jsxs("div", __assign({ className: "row campaign-main-row" }, { children: [_jsx("div", __assign({ className: "col-12 col-lg-6" }, { children: _jsx("img", { className: "campaign-detail-image", src: env.cdn_host + campaign.photo, alt: campaign.name }) })), _jsx("div", __assign({ className: "col-12 col-lg-6" }, { children: _jsxs("div", __assign({ className: "campaign-info-section" }, { children: [_jsxs("div", __assign({ className: "campaign-header-row" }, { children: [_jsx("div", { children: _jsx("h2", __assign({ className: "campaign-name" }, { children: campaign.name })) }), _jsx("button", __assign({ className: "btn btn-back-inside", onClick: function () { return navigate(paths.campaign.url); } }, { children: "\u2190 Kampanyalara D\u00F6n" }))] })), _jsx("p", __assign({ className: "campaign-subtitle" }, { children: campaign.title_abbreviated })), campaign.is_valid && campaign.is_member_join && (_jsx("button", __assign({ type: "button", disabled: !campaign.show_button, onClick: function () {
                                                        if (campaign.show_button) {
                                                            joinCampaign(campaign.id);
                                                        }
                                                    }, className: "btn ".concat(campaign.show_button ? 'btn-join-campaign' : 'btn-campaign-joined') }, { children: campaign.show_button ? 'Kampanyaya Katıl' : "KAMPANYA'YA KATILDIN" })))] })) }))] })), _jsx("div", __assign({ className: "row campaign-details-row" }, { children: _jsx("div", __assign({ className: "col-12" }, { children: _jsxs("div", __assign({ className: "campaign-detail-content" }, { children: [_jsx("h2", { children: "Kampanya Detaylar\u0131" }), _jsx("p", { className: "info", dangerouslySetInnerHTML: {
                                                    __html: campaign.description.replaceAll("\n", "<br/>"),
                                                } }), _jsx("h2", { children: "Kat\u0131l\u0131m \u015Eartlar\u0131" }), _jsx("p", { className: "info", dangerouslySetInnerHTML: {
                                                    __html: campaign.participation_requirement.replaceAll("\n", "<br/>"),
                                                } })] })) })) }))] })) })) }))] })));
}
